import type { DocumentVisibility } from "@gencow/core";
import {
  parsePrivateExternalCorpusAllowlist,
  resolveAllowExternalProvidersPolicy,
  type RagCorpusPolicyDbLike,
} from "./rag-corpus-policy.js";
import { upsertRagCorpus } from "./rag-ingest-jobs.js";

type EnsureRagCorpusPolicyParams = {
  db: RagCorpusPolicyDbLike;
  corpus: string;
  visibility: DocumentVisibility;
  ownerUserId: string | null;
  metadata: Record<string, unknown>;
};

export function configuredPrivateExternalCorpora(
  envValue = process.env.GENCOW_DOCUMENT_EXTERNAL_PRIVATE_CORPORA,
): string[] {
  return parsePrivateExternalCorpusAllowlist(envValue);
}

export async function ensureRagCorpusPolicy(params: EnsureRagCorpusPolicyParams): Promise<boolean> {
  const allowExternalProviders = await resolveAllowExternalProvidersPolicy({
    db: params.db,
    corpus: params.corpus,
    visibility: params.visibility,
    ownerUserId: params.ownerUserId,
    allowPrivateExternalCorpora: configuredPrivateExternalCorpora(),
  });

  await upsertRagCorpus(params.db as Parameters<typeof upsertRagCorpus>[0], {
    corpus: params.corpus,
    visibility: params.visibility,
    ownerUserId: params.ownerUserId,
    allowExternalProviders,
    metadata: params.metadata,
  });

  return allowExternalProviders;
}
